import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import InlineButton from 'shared/components/InlineButton';
import * as Colors from 'material-ui/styles/colors';
import Radium from 'radium';
import Popover from 'material-ui/Popover/Popover';
import * as ConnectEbayAccountService from 'shared/helpers/ConnectEbayAccountService';
import {EBAY_CONNECT_STATUS} from 'shared/helpers/ConnectEbayAccountService';
import { closeLazyPanel, openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import LinearProgress from 'material-ui/LinearProgress';
import {openPublishDialog} from 'crazyEditor/redux/modules/publishDialog/publishDialog';
import EbaySitesDropMenu from 'shared/components/EbaySitesDropMenu/EbaySitesDropMenu';
import {setEBayAccounts} from 'MyAccount/ViewDesigns/redux/modules/accountPage';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import _ from 'lodash';

const styles = {
  body: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: 0,
    width: 750,
    height: 466,
    minHeight: 466,
  },
  headline: {
    fontSize: 50,
    fontFamily: '"Acme", sans-serif',
    color: Colors.orange800
  },
  text: {
    fontSize: 20,
    color: Colors.grey700,
  }
};

const STATUS = {
  INITIAL: 0,
  DUPLICATE: 1,
  ERROR: 2,
};

const backgroundImages = {};
backgroundImages[STATUS.INITIAL] = require('./images/connect-ebay-background.svg');
backgroundImages[STATUS.DUPLICATE] = require('./images/connect-ebay-duplicate.svg');
backgroundImages[STATUS.ERROR] = require('./images/connect-ebay-fail.svg');

const INITIAL_STATE = {
  status: STATUS.INITIAL,
  showWhyConnect: false,
  anchorEl: null,
  waitingForEbayPopup: false,
};

@connect(
  (state) => ({
    tempUser: state.user.tempUser,
  }),
  { closeLazyPanel, openLazyPanel, openPublishDialog, setEBayAccounts },
)
@Radium
export default class ConnectEbayDialog extends Component {
  state = INITIAL_STATE;

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.setState(INITIAL_STATE);
    }
  }

  onConnectEbayClicked = () => {
    this.setState({waitingForEbayPopup: true});
    ConnectEbayAccountService.launchAuth(this.ebayConnectCallback);
  };

  handleClose = () => {
    const {closeLazyPanel, panelName} = this.props;
    closeLazyPanel(panelName);
  };

  showWhyConnect = (event) => {
    this.setState({
      showWhyConnect: true,
      anchorEl: event.target,
    });
  };

  hideWhyConnect = () => {
    this.setState({showWhyConnect: false});
  };

  ebayConnectCallback = (ebayStatus, data) => {
    const {openPublishDialog, setEBayAccounts, panelProps: {onSuccess}} = this.props;
    let status;
    switch (ebayStatus) {
      case EBAY_CONNECT_STATUS.SUCCESS:
      case EBAY_CONNECT_STATUS.SWITCHED:
        this.handleClose();
        if (_.isFunction(onSuccess)) {
          onSuccess();
        } else {
          openPublishDialog(true);
        }
        setEBayAccounts(data.eBayAccounts);
        break;
      case EBAY_CONNECT_STATUS.DUPLICATE:
        const {tempUser, openLazyPanel} = this.props;
        if (tempUser) {
          this.handleClose();
          openLazyPanel(EDITOR_PANELS.LOGIN, TYPES.EDITOR_PANEL, {}, {ebayConnectEmail: data.ebayConnectEmail, duplicateErrorMessage: data.duplicateErrorMessage});
        }
        status = STATUS.DUPLICATE;
        break;
      case EBAY_CONNECT_STATUS.ERROR:
        status = STATUS.ERROR;
        break;
      case EBAY_CONNECT_STATUS.CANCEL:
      default:
        break;
    }
    const newState = {...INITIAL_STATE, waitingForEbayPopup: false};
    if (status) {
      newState.status = status;
    }
    this.setState(newState);
  };

  render() {
    const {status, anchorEl, showWhyConnect, waitingForEbayPopup} = this.state;
    const {open} = this.props;
    let content;
    let primaryButtonLabel;
    switch (status) {
      case STATUS.INITIAL:
        primaryButtonLabel = 'CONNECT MY EBAY ACCOUNT';
        content = (
          <div
            style = {{
              position: 'absolute',
              top: 130,
              left: 200
            }}
          >
            <div
              style = {styles.headline}
            >
              CONGRATS!
            </div>
            <div
              style = {styles.text}
            >
              <p>
                It is your first professional listing!
                You are just one minute away from publishing it.
              </p>
              <p>
                Next you’ll be taken to eBay for logging into your
                account and connecting it to your Crazylister account
              </p>
              <InlineButton
                ref = "whyConnect"
                label = "Why do I need to connect my eBay account?"
                onClick = {this.showWhyConnect}
                style = {{fontSize: 16}}
              />
              <Popover
                open = {showWhyConnect}
                anchorEl = {anchorEl}
                anchorOrigin = {{horizontal: 'middle', vertical: 'center'}}
                targetOrigin = {{horizontal: 'middle', vertical: 'center'}}
              >
                <div
                  style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
                >
                  <div
                    style={{display: 'flex', marginLeft: 20, marginRight: 20, marginTop: 20, marginBottom: 10}}
                  >
                    <div>
                      <img src="/images/ebay-connect-compatibale.png"/>
                    </div>
                    <div
                      style={{width: 400, fontSize: 16, marginLeft: 20}}
                    >
                      Making Crazylister fully functional requires a connection to an eBay account. CrazyLister is an eBay certified developer. Your data is safe with us.
                      We do not rent, share or sell your personal information. Ever.
                    </div>
                  </div>
                  <FlatButton
                    label = "ok, got it"
                    onClick= {this.hideWhyConnect}
                    style={{width: 120, marginBottom: 20}}
                  />
                </div>
              </Popover>
            </div>
          </div>);
        break;
      case STATUS.DUPLICATE:
        primaryButtonLabel = 'TRY WITH A DIFFERENT ACCOUNT';
        content = (
          <div
            style = {{
              position: 'absolute',
              top: 100,
              left: 400,
            }}
          >
            <div
              style = {styles.headline}
            >
              OOPS!
            </div>
            <div
              style = {styles.text}
            >
              <p>
                This eBay account is already<br/>
                connected to a different CrazyLister account
              </p>
            </div>
          </div>);
        break;
      case STATUS.ERROR:
        primaryButtonLabel = 'OK, TRY AGAIN';
        content = (
          <div
            style = {{
              position: 'absolute',
              top: 100,
              left: 400,
            }}
          >
            <div
              style = {styles.headline}
            >
              WHOOPSIE!
            </div>
            <div
              style = {styles.text}
            >
              <p>
                Something went wrong<br/>
                eBay Authentication failed
              </p>
            </div>
          </div>);
        break;
      default:
        break;
    }

    return (
      <Dialog
        open = {open}
        bodyStyle = {{
          ...styles.body,
          backgroundImage: 'url(' + backgroundImages[status] + ')',
        }}
        contentStyle={styles.body}
      >
        <IconButton
          onClick={() => {this.handleClose();}}
          iconStyle={{color: 'grey'}}
          style = {{
            position: 'absolute',
            right: 0
          }}
        >
          <FontIcon className="material-icons" >close</FontIcon>
        </IconButton>
        {content}
        <div style = {{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', position: 'absolute', bottom: 20, right: 20}}>
          <EbaySitesDropMenu/>
          <RaisedButton
            label = {waitingForEbayPopup ? 'AWAITING EBAY AUTHORIZATION' : primaryButtonLabel}
            primary
            onClick = {this.onConnectEbayClicked}
            style = {{
              marginLeft: '20px'
            }}
            disabled={waitingForEbayPopup}
            >
            { waitingForEbayPopup &&
            <LinearProgress mode="indeterminate" style={{position: 'absolute', bottom: 0, left: 0, width: '100%', backgroundColor: 'none'}}/>
            }
        </RaisedButton>
      </div>
  </Dialog>
    );
  }
}
